import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { SpecialUsageMapService } from '@ui/shared/util-api';
import type { ProjectListFilterKey } from '../../types/project-list-filters';

@Injectable({ providedIn: 'root' })
export class SpecialUsageKindSelectFilterConfigService extends FilterConfigService<ProjectListFilterKey, SpecialUsageMapService> {

    constructor() {
        super(
            new MultiFilterModel('specialUsageKind', 'Art der Sondernutzung', []),
            inject(SpecialUsageMapService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllSpecialUsageKinds({
            order: [],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
